import { Dismissed } from '@/srp/Banners/PromoBanner/constants';
import { SearchDispatcherEvent } from '~/native/srp/dispatchers/constants';
import sendMessageToNative from '~/native/srp/dispatchers/sendMessageToNative';
import BrowserCookies from '~/utilities/BrowserCookies';
import { PromoBanners } from './constants';

const FOURTEEN_DAYS_MS = 14 * 24 * 60 * 60 * 1000;

function sendNativeDismissEvent(
  banner: PromoBanners,
  cookie: string,
  dismissed: Dismissed
) {
  sendMessageToNative(SearchDispatcherEvent.DismissBanner, {
    bannerName: PromoBanners[banner],
    cookieName: cookie,
    expirationDate: new Date(Date.now() + FOURTEEN_DAYS_MS).toISOString(),
    value: dismissed
  });
}

export function setBannerDismissedCookie(banner: PromoBanners, cookie: string) {
  const expires = new Date(Date.now() + FOURTEEN_DAYS_MS);

  BrowserCookies.set(cookie, String(Dismissed.Banner), {
    expires,
    path: '/'
  });

  sendNativeDismissEvent(banner, cookie, Dismissed.Banner);
}

export function getBannerName(banner: PromoBanners): string {
  switch (banner) {
    case PromoBanners.Geico:
      return 'GEICO Discount';
    case PromoBanners.NCC:
      return 'NCC';
    case PromoBanners.PriceDrop:
      return 'Price Drop';
    case PromoBanners.Root:
      return 'Root Discount';
    case PromoBanners.WSYS:
      return 'WSYS';
  }
}
